import { ActionIcon, Box, Button, Image, Modal } from "@mantine/core";
import { IconX } from "@tabler/icons-react";

export type PromoPopModalData = {
  id: string;
  imageUrl: string;
  linkUrl: string | null;
  buttonLabel: string;
};

type PromoPopModalProps = {
  opened: boolean;
  promo: PromoPopModalData | null;
  onClose: () => void;
  onCta: () => void;
};

const MODAL_NAVY = "#04305c";

/**
 * Full-image promo popup (same UX as sector promos).
 * Close on image (top-right); CTA below uses admin-defined button name.
 */
export default function PromoPopModal({ opened, promo, onClose, onCta }: PromoPopModalProps) {
  const hasLink = Boolean(promo?.linkUrl?.trim());
  const ctaLabel = promo?.buttonLabel?.trim() || "Open";

  return (
    <Modal
      opened={opened && Boolean(promo)}
      onClose={onClose}
      centered
      size="auto"
      padding={0}
      radius="lg"
      withCloseButton={false}
      title=""
      overlayProps={{ backgroundOpacity: 0.6, blur: 2 }}
      styles={{
        body: { padding: 0 },
        content: {
          overflow: "visible",
          backgroundColor: "transparent",
          boxShadow: "none",
          maxWidth: "min(920px, 96vw)",
        },
      }}
    >
      {promo ? (
        <Box>
          <Box
            pos="relative"
            style={{
              borderRadius: 16,
              overflow: "hidden",
              backgroundColor: "#FFFFFF",
              lineHeight: 0,
              cursor: hasLink ? "pointer" : undefined,
            }}
            onClick={hasLink ? onCta : undefined}
          >
            <Image
              src={promo.imageUrl}
              alt=""
              fit="contain"
              mah="min(76vh, 700px)"
              maw="min(920px, 96vw)"
              style={{ display: "block", width: "100%", height: "auto" }}
            />

            <ActionIcon
              variant="filled"
              color="dark"
              radius="xl"
              size="lg"
              aria-label="Close"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              style={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 2,
                backgroundColor: "rgba(15, 23, 42, 0.72)",
              }}
            >
              <IconX size={18} />
            </ActionIcon>
          </Box>

          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 0,
            }}
          >
            <Box
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: 8,
                borderRadius: "0 0 10px 10px",
                border: "1px solid #E2E8F0",
                borderTop: "none",
                backgroundColor: "#FFFFFF",
              }}
            >
              <Button
                size="md"
                radius="md"
                onClick={onCta}
                styles={{
                  root: {
                    fontWeight: 600,
                    backgroundColor: MODAL_NAVY,
                    color: "#FFFFFF",
                    minWidth: 160,
                    "&:hover": { backgroundColor: "#042f5c" },
                  },
                }}
              >
                {ctaLabel}
              </Button>
            </Box>
          </Box>
        </Box>
      ) : null}
    </Modal>
  );
}
